import { Dispatch } from 'react';
import { get } from 'communication/httpClient';
import {
  CLEAN_TAX_AUTHORITIES,
  SET_TAX_AUTHORITIES_LIST,
  SYNC_FAILED,
  SYNC_FINISHED,
  SYNC_INITIATED,
} from './actionTypes';
import { ITaxAuthoritiesAction, ITaxAuthoritiesActions } from './types';

export const initialActionsState = {
  loadTaxAuthorities: () => {},
  cleanTaxAuthorities: () => {},
};

export const getActions = (dispatch: Dispatch<ITaxAuthoritiesAction>): ITaxAuthoritiesActions => ({
  loadTaxAuthorities: async () => {
    dispatch({
      type: SYNC_INITIATED,
    });
    const { data, error } = await get('/api/tax-authorities');

    if (data) {
      dispatch({
        type: SET_TAX_AUTHORITIES_LIST,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  cleanTaxAuthorities: () => {
    dispatch({
      type: CLEAN_TAX_AUTHORITIES,
    });
  },
});
